/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"RegistrationPolicy":"RegistrationPolicy_ySDkm","checkbox":"checkbox_Uriyy","text":"text_CuJxg"};